module.exports = __webpack_public_path__ + "media/images/team4-0a888901.jpg";